import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  InMemoryCache,
} from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import React from "react";
import ReactDOM from "react-dom/client";

import * as Sentry from "@sentry/react";

import App from "App";
import "css/App.css";

import reportWebVitals from "reportWebVitals";
import { API_URL, COOKIES } from "settings";
import { getCookie } from "utils/helpers";

if (import.meta.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.REACT_APP_SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing()],
    environment: import.meta.env.REACT_APP_ENV,
    tracesSampleRate: 0.1,
    // apollo-upload-client aborts its fetch on every subscription cleanup, even after success
    ignoreErrors: [/signal is aborted without reason/],
  });
}

const apolloLink = createUploadLink({
  uri: API_URL,
  credentials: "include",
  headers: {
    "X-CSRFToken": getCookie(COOKIES.CSRF) || "",
  },
});

const client = new ApolloClient({
  link: apolloLink as unknown as ApolloLink,
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
);

reportWebVitals();
